import React, {useEffect} from 'react';
import {
	LegacyFormAttribute,
	type LegacyFormAttributeProps,
} from '@netx/core-attribute/components/Attribute';
import {
	withForm,
	WithFormPropsIn,
	WithFormPropsOut,
} from '@netx/core-components/Form';
import {withTheme} from '@netx/core-components/Theme';
import {withQueryClient} from '@netx/core-next/lib';

export interface CellEditorProps
	extends WithFormPropsIn,
		Omit<LegacyFormAttributeProps, 'form'> {
	onChange(value: any): void;
}

/** For cell editing within the hypergrid */
const CellEditor: React.FC<WithFormPropsOut<CellEditorProps>> = ({
	onChange,
	form,
	...props
}) => {
	useEffect(() => {
		onChange(form.values[props.attrData.name]);
	}, [form.values, props.attrData.name]);

	return (
		<LegacyFormAttribute
			{...props}
			limitHeightToContainer
			matchContainerHeight
			form={form}
			hideLabel
			name={props.attrData.name}
			value={form.values[props.attrData.name]}
		/>
	);
};

export default withQueryClient(
	withTheme(withForm<CellEditorProps>(CellEditor as any)),
);
